import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SITE = "https://rawresponselabs.com";

interface PageMetaProps {
  title: string;
  description: string;
  /** Optional path override; defaults to current route. */
  path?: string;
}

/**
 * Per-route <title>, <meta name="description">, canonical, and og:*.
 * <meta> tags dedupe by name/property so these replace the sitewide
 * fallbacks from index.html for JS-executing crawlers.
 */
const PageMeta = ({ title, description, path }: PageMetaProps) => {
  const location = useLocation();
  const url = `${SITE}${path ?? location.pathname}`;
  const desc = description.length > 158 ? description.slice(0, 155) + "..." : description;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
};

export default PageMeta;
